export default __webpack_public_path__ + "static/media/costo_empresas.2629aed4.jpg";